/**
 * 🧱 Refactor BT Phase 4 — 4.1 (B-1) : date du jour MÉTIER côté frontend = date du Québec.
 * `new Date().toISOString().slice(0, 10)` renvoie la date UTC (déjà « demain » après 20h au Québec).
 * Même règle que `backend/services/bt_dates.date_du_jour_quebec()`.
 */
export const FUSEAU_QUEBEC = 'America/Toronto';

export function dateDuJourQuebec(maintenant = new Date()) {
  return maintenant.toLocaleDateString('en-CA', { timeZone: FUSEAU_QUEBEC });
}
